import ApiClient from './ApiClient'

// Dedupe concurrent calls for the same collectId.
// FiltersButton (header) and Progression both fetch on mount.
// Cleared once the request settles.
const inFlightCollects = new Map()

class CollectService {
  static getCollectData(collectId) {
    const cached = inFlightCollects.get(collectId)
    if (cached)
      return cached
    const promise = ApiClient.get(`/collects/${collectId}.json`)
    inFlightCollects.set(collectId, promise)
    promise.finally(() => {
      if (inFlightCollects.get(collectId) === promise)
        inFlightCollects.delete(collectId)
    })
    return promise
  }

  static fetchSectionQuestions(collectId, sectionId) {
    return ApiClient.get(`/collects/${collectId}/sections/${sectionId}/questions.json`)
  }

  static getQuestions(collectId) {
    return ApiClient.get(`/collects/${collectId}/questions.json`)
  }

  static getVariables(collectId) {
    return ApiClient.get(`/collects/${collectId}/variables.json`)
  }
}

export default CollectService